class InquiryForm extends Component {

	/**
	 * @param {HTMLElement} el
	 */
	constructor(el) {
		super(el);
		this.productHiddenInput = el.querySelector('[name="products"]');
		this.productContainer = el.querySelector('[data-products]');
		this.toggleMoreProductsButton = el.querySelector('[data-toggle-more-products]');
		this.initializeProductSelector();
		this.postalCodeInput = el.querySelector('[name="postalCode"]');
		this.cityInput = el.querySelector('[name="city"]');
		this.regionInput = el.querySelector('[name="region"]');
		this.countryInput = el.querySelector('[name="country"]');
		this.initializePostalCodeInput();
	}

	applySelectedProducts() {
		const productList = {};
		let products = this.productContainer.querySelectorAll('[data-product-id].is-selected');
		products.forEach(product => {
			productList[String(product.dataset.productId)] = product.dataset.productTitle;
		});
		this.productHiddenInput.value = JSON.stringify(productList);
	}

	initializeProductSelector() {
		let initialSelectedProductIds = [];
		if (this.productHiddenInput.value) {
			let products = JSON.parse(this.productHiddenInput.value);
			initialSelectedProductIds = Object.keys(products);
		}
		else if (location.search) {
			const params = new URLSearchParams(location.search);
			let id = parseInt(params.get("product"), 10);
			if (id) {
				initialSelectedProductIds = [id];
			}
		}

		const products = this.productContainer.querySelectorAll('[data-product-id]');
		products.forEach(product => {
			product.addEventListener('click', () => {
				product.classList.toggle('is-selected');
				this.applySelectedProducts();
			});
		});
		initialSelectedProductIds.forEach((id) => {
			let initialSelectedProduct = this.productContainer.querySelector('[data-product-id="' + id + '"]');
			if (initialSelectedProduct) {
				initialSelectedProduct.classList.add('is-selected');
			}
		})

		this.applySelectedProducts();

		this.toggleMoreProductsButton.addEventListener('click', () => {
			this.productContainer.classList.toggle('is-open');
		})
	}

	initializePostalCodeInput() {
		if (!this.postalCodeInput) {
			return;
		}
		const select2Instance = $(this.postalCodeInput).select2({
			minimumInputLength: 3,
			ajax: {
				url: this.postalCodeInput.parentElement.parentElement.dataset.source,
				dataType: 'json'
			}
		});
		select2Instance.on('select2:select', (e) => {
			this.cityInput.value = e.params.data.city;
			this.regionInput.value = e.params.data.region;
			this.countryInput.value = e.params.data.country;
		});
		select2Instance.on('change', () => {
			this.postalCodeInput.dispatchEvent(new CustomEvent('postalcode-changed')); // emulace tradičního DOM eventu
		});
		$(this.postalCodeInput).data('select2Instance', select2Instance);
	}
}